// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"59e3a908","453":"f4889680","455":"72a4a410"}[chunkId] + ".chunk.js";
};